<div style="display: flex;flex-direction: column;align-items: center;
justify-content: center;flex:1;align-self: center;">



  <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;">
      <span *ngIf="PolicyId == 0" style="font-size: 25px;">Upload Polices and Procedures</span>
    <span *ngIf="PolicyId > 0" style="font-size: 25px;">Upload Polices and Procedures</span>

    <button  style="float: right; margin-bottom: 1%;" class="button button--primary"><span class="button__text"
      (click)="NavigateToSearch()">Return to Search Screen</span></button>
   
    <!-- </div> -->
    <div class="search-options"
      style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height:auto;">
    
      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="State" [formControl]="buildStateFormControl"  [(ngModel)]="SelectedState" multiple required>
          <mat-option (click)="selectAllState(ev)"    [value]="0"
          #ev
           >Select All</mat-option>
          <mat-option [value]="state.Id" *ngFor="let state of StateList" (click)="stateChange(state.Id)" >{{state.SiteName}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Department" [formControl]="buildDepartmentFormControl"  [(ngModel)]="SelectedDepartment" multiple required>
          <mat-option (click)="selectAllDepartment(ev)"    [value]="0"
          #ev
           >Select All</mat-option>
          <mat-option [value]="dept.ID" *ngFor="let dept of filteredwDepartmentlist" (click)="departmentChange(dept.ID)" >{{dept.DepartmentName}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Work Area" [formControl]="buildnoFormControl"  [(ngModel)]="SelectedWorkArea" multiple required>
          <mat-option (click)="selectAllWorkArea(ev)"    [value]="0"
          #ev
           >Select All</mat-option>
          <mat-option [value]="model.ID" *ngFor="let model of filteredWorkList" (click)="workAreaChange(model.ID)" >{{model.WorkAreaName}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-label>Form Header</mat-label>
        <input type="text" matInput placeholder="Form Header" [(ngModel)]="policyName"  required />
      </mat-form-field>
      

      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>
      <br/>
      
      <div style="display: flex;min-width: 30%;height:40px">
       
     
        
        <i *ngIf="FilePreview!=''" style="cursor: pointer;vertical-align: bottom; margin-left: 10%;font-size: 40px; color: #3da14b;"
          class="material-icons" class="material-icons" (click)="onClickDownloadForm()">description</i>
          <span *ngIf="NewFileName!=''"style="cursor: pointer;font-size: 13px; max-width: 10em;    overflow-wrap: break-word;">{{NewFileName}}</span>
        Attach Doc.
      <i   class="material-icons" (click)="openAttachDoc()" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; ">add</i>        
  </div>
      <!-- <div style="display: flex;min-width: 30%;height:40px">
       
        <span style="cursor: pointer;font-size: 14px;margin-top: 23px">File </span>
        <input type="file" style="margin-top: 18px;margin-left: 10px" name="upload" accept="application/pdf" (change)="onFileChanged($event);" >
          <div *ngIf="PolicyId > 0 && FilePreview != ''" style="display: flex;height:40px;justify-content: left;">
            <i style="cursor: pointer;vertical-align: bottom; margin-left: 10%;font-size: 40px;
            color: #3da14b;"
              class="material-icons" class="material-icons" (click)="onClickDownloadForm()">description</i>
              <span style="cursor: pointer;font-size: 13px; max-width: 10em;    overflow-wrap: break-word;">{{FileName}}</span>
          </div>      
                  
      </div> -->
        
  <div style="display: flex;" class="sc-row-margin">
    <div style="flex: 1">
      <h4 style="font-size: 14px;" class="get-label">Notes</h4>     
        <mat-form-field style="width: 1000px;">  
          <textarea class="sc-textarea" matInput [(ngModel)]="note" [ngModelOptions]="{standalone: true}"></textarea>
        </mat-form-field>    
    </div>
  </div>
    
  <mat-form-field class="header-form-full-width invisible">
    <mat-select name="customer" class="invisible">
    </mat-select>
  </mat-form-field>
     
      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerStart" [(ngModel)]="issuedDate" required>
        <mat-placeholder>Issued Date</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="expiredDate" >
        <mat-placeholder>Expired Date</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>
      
      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>
      
      <div style="min-width: 30%;width: 30%;"></div>

      <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
        <button (click)="ResetFields()" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
          >Reset</span></button>
        <button  *ngIf="PolicyId == 0" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
          (click)="savePolicyProcedure()" >Save</span></button>
        <button *ngIf="PolicyId > 0" (click)="updatePolicyProcedure()" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
            >Update</span></button>
      </div>

    </div>
  </mat-card>

</div>